<template>
  <v-dialog
    v-model="showPopup"
    persistent
    max-width="520"
    @keydown.passive.enter='$emit("delete")'
    @keydown.passive.esc='$emit("cancel")'
  >
    <v-card class="pa-4">
      <v-card-title class="headline justify-center popup-title">
        Are you sure want to remove the user role{{role ? ` "${role}"` : ''}}?
      </v-card-title>
      <v-card-text v-if='(+usersCount>0)' class="d-flex justify-center red--text">
        <p class="text-center">Attention! This role is set for {{usersCount}} users.</p>
      </v-card-text>
      <v-card-actions class="text-xs-center justify-center">
        <v-btn
          @click="$emit('cancel')"
          depressed
          class="cancel-btn small-size"
        >
          Cancel
        </v-btn>
        <v-btn
          @click='$emit("doDelete")'
          depressed
          class="save-btn small-size"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'rolesDeleteSinglePopup',
  props: {
    role: {
      type: String,
      default: '',
      required: true
    },
    usersCount: {
      type: [Number, String],
      required: true
    }
  },
  data: () => ({
    showPopup: true
  })
}
</script>
